export default __webpack_public_path__ + "static/margo_ovsiienko-134728b318eebc56c99dea44077dbc77.png";